import domready from 'domready'
import VideoPlayerController from './lib/video-player-controller'
import VideoPlayerRegistry from './lib/video-player-registry'

export default function initVideoPlayers () {
  domready(() => {
    const videoPlayerRegistry = new VideoPlayerRegistry()
    const videoPlayerElements = document.querySelectorAll('.video-player')
    ;[].forEach.call(videoPlayerElements, (element) => {
      videoPlayerRegistry.add(new VideoPlayerController(element, videoPlayerRegistry))
    })
  })
}
